
const defaultState = function () {
  return {
    mode: 0, // 0: 通常, 1: 注文編集, 2: 交換出荷, 3: 返品登録
    returnList: false, // オペレーションボタンから編集モードに遷移したか
    tableSetList: [{}],
    tdLists: [],
    totalCount: 0,
    listIndex: -1,
    currentPage: 0,
    size: 10,
    isAndSearch: false,
    searchKeyword: '',
    searchKey: 'sales_product_digital_list',
    maxGetCount: null,
    // 検索条件
    searchConditions: {},
    // 表示項目
    displayItems: []
  }
}

export default {
  namespaced: true,
  state: defaultState(),
  getDefaultState: defaultState
}
